import { Routes, Route } from 'react-router-dom';
import { EmailProvider } from './context/EmailContext';
import Layout from './components/layout/Layout';
import ContactModal from './components/ContactModal';
import Home from './pages/Home';
import Services from './pages/Services';
import About from './pages/About';
import Contact from './pages/Contact';

export default function App() {
  return (
    <EmailProvider>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </Layout>
      <ContactModal />
    </EmailProvider>
  );
}
